import axios from "axios";
import { Message } from "view-design";
import router from "@/router";
import { showLoading, closeLoading } from "@/utils/loading";
import { resetTokenAndClearUser } from "@/utils";

const service = axios.create({
  baseURL: window.location.origin,
  timeout: 60000,
});
// service.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
service.defaults.headers.post["Content-Type"] =
  "application/json;charset=UTF-8"; // 配置请求头

service.interceptors.request.use(
  (config) => {
    showLoading();
    if (localStorage.getItem("token")) {
      config.headers.Authorization = localStorage.getItem("token");
    }
    return config;
  },
  (error) => Promise.reject(error)
);

service.interceptors.response.use(
  (response) => {
    closeLoading();

    const res = response.data;
    // 这里是接口处理的一个示范，可以根据自己的项目需求更改
    // 错误处理
    // res.code= 1
    if (res.code != 0 && res.msg) {
      if (
        response.config.url.includes("/api/visit/getStoresInfo") ||
        response.config.url.includes("/web/clueDistributionRuleInfo/create") ||
        response.config.url.includes("/login/check/verification/result") ||
        response.config.url.includes("/api/login/sendCaptcha") ||
        response.config.url.includes("/api/login/verifyCodeCheck")
      ) {
        return Promise.resolve(res);
      } else {
        Message.error({ content: res.msg });
        // token 无效，清空路由，退出登录
        if (res.code == 2) {
          resetTokenAndClearUser();
          router.push("login");
        }
      }
      return Promise.reject();
    }
    // 如果接口正常，直接返回数据
    return res;
  },
  (error) => {
    closeLoading();
    //如果是 401 说明登陆失效 重新登陆
    if (error.response.status == 401) {
      resetTokenAndClearUser();
      router.push("login");
      return Promise.reject(error);
    } else if (error.response.status == 403) {
      Message.error("您没有操作权限");
      return Promise.reject(error);
    } else if (error.name == "Error") {
      Message.error({
        content: error.msg,
      });
    } else {
      Message.error({
        content: error.response.data.data || error.message,
      });
    }

    return Promise.reject(error);
  }
);

export default service;
